import { TimelineMax } from 'gsap';
import { useEffect, useMemo, useState } from 'react';
import { arraysAreEqual } from './arraysAreEqual';
import { createGsapTransition } from './animate';
export const useAnimation = (animationList, path, refs, delayMap = {}, fieldData, dontAnimate = false, needsReset = false) => {
    const desiredState = useMemo(() => path, [path]);
    const [{ state, direction, to }, setState] = useState({ state: [], direction: 0, to: undefined });
    const handleTransition = (refs, animationList, state, desiredState, setState) => {
        let direction = 0;
        let directionChange = false;
        const copy = [...state];
        const transitions = [];
        const push = (newPathSegment) => {
            if (direction < 0) {
                directionChange = true;
                return;
            }
            direction = 1;
            copy.push(newPathSegment);
            transitions.push(`show:${newPathSegment}`);
        };
        const pop = () => {
            direction = -1;
            transitions.push(`hide:${copy[copy.length - 1]}`);
            copy.pop();
        };
        while (!directionChange && !arraysAreEqual(copy, desiredState)) {
            if (copy.length > desiredState.length) {
                pop();
            }
            else if (desiredState.length > copy.length) {
                if (arraysAreEqual(desiredState.slice(0, copy.length), copy)) {
                    push(desiredState[copy.length]);
                }
                else {
                    pop();
                }
            }
            else {
                pop();
            }
        }
        const timeline = new TimelineMax({
            onStart: () => setState({ state, direction, to: copy }),
            onComplete: () => setState({ state: copy, direction: 0, to: undefined })
        });
        transitions.forEach((transition, index) => {
            const [type, name] = transition.split(':');
            let transitionDelay = '';
            if (index) {
                const prevTransition = transitions[index - 1];
                const [prevType, prevName] = prevTransition.split(':');
                transitionDelay =
                    delayMap[`${prevType}:${prevName} ${type}:${name}`] ||
                        delayMap[`${type}:${name}`] ||
                        delayMap[`${type}Default`];
            }
            let reverse = false;
            let segment = Object.entries(animationList).find(([key]) => key === name)[1][type];
            if (segment === 'reverseShow') {
                reverse = true;
                segment = Object.entries(animationList).find(([key]) => key === name)[1].show;
            }
            const transitionTimeline = typeof segment === 'function'
                ? segment(refs, fieldData)
                : createGsapTransition(refs, segment);
            if (reverse)
                transitionTimeline.timeScale(1.5).reverse(0);
            timeline.add(transitionTimeline, transitionDelay);
        });
        if (dontAnimate) {
            timeline.progress(1);
        }
        else {
            timeline.play();
        }
    };
    useEffect(() => {
        if ((!arraysAreEqual(state, desiredState) || needsReset) && !direction) {
            handleTransition(refs, animationList, state, needsReset ? [] : desiredState, setState);
        }
    }, [state.join(), desiredState.join(), needsReset]);
    return { animating: !!direction, direction, desiredState, state, to };
};
//# sourceMappingURL=useAnimation.js.map